module.exports = __webpack_public_path__ + "media/Amaterasu.663e5fc7.mp3";